import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {AuthService} from "../../../../Services/auth.service";
import {Router} from "@angular/router";
import {ApiServiceService} from "../../../../Services/api-service.service";

@Component({
  selector: 'app-mda-header',
  templateUrl: './mda-header.component.html',
  styleUrls: ['./mda-header.component.css']
})
export class MdaHeaderComponent implements OnInit {
  collapsed = true;
  isNotifyOpen:boolean = false;
  displayName: any;
  @ViewChild('myFooter') myDiv!: ElementRef;
  @ViewChild('subFooter') subFooter!: ElementRef;


  constructor(
      public authService: AuthService,
      private router: Router,
      private authenticationService: AuthService,
      private elementRef: ElementRef,
      private apiService: ApiServiceService
  ) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isNotifyOpen = false
    }
  }

  ngOnInit(): void {
    this.displayName = this.authService.getDisplayName();
    this.getNotification();
    console.log(this.authService.getLogo())

    setTimeout(() => {
      this.myDiv.nativeElement.style.backgroundColor = this.authService.getPrimaryColor();
      this.subFooter.nativeElement.style.backgroundColor = this.authService.getSecondaryColor();

      const links = this.elementRef.nativeElement.querySelectorAll('a');
      links.forEach((link: HTMLElement) => {
        link.style.color = this.authService.getSecondaryTextColor();
      });
      const h3 = this.elementRef.nativeElement.querySelectorAll('h3');
      h3.forEach((link: HTMLElement) => {
        link.style.color = this.authService.getSecondaryTextColor();
      });
      const p = this.elementRef.nativeElement.querySelectorAll('p');
      p.forEach((link: HTMLElement) => {
        link.style.color = this.authService.getSecondaryTextColor();
      });
    });

  }

  logout() {
    this.authenticationService.logout();
  }

  hasAccess(permissions: string[]) {
    return this.authenticationService.hasAnyPermission(permissions);
  }

  home() {
    this.router.navigate(["/"]);
  }

  navigateToAnnualReturn(annualReturnType: string): void {
    this.router.navigate(["/admin/annual-returns"], {
      queryParams: { q: annualReturnType },
    });
  }
  toggleNotification() {
    this.isNotifyOpen = !this.isNotifyOpen
  }

  notification:any[]=[]
  total:any;

  getNotification(){
    const url = `/assessments/get/notification`;
    this.apiService.get(url).subscribe(res=>{
      this.total = res.total;
      this.notification = res.results;
    })
  }

  notify(inactive: string, id:number) {
    const url = `/assessments/delete/notification?id=${id}&action=${inactive}`;
    this.apiService.post_(url, {}).subscribe(res=>{
      this.getNotification();
    })
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/img/default-logo.png';
  }
}
